import React, { createContext, useContext, useMemo } from 'react';
import type {
	IssueNavigatorFeaturesContext,
	IssueNavigatorFeatureProviderProps,
	IssueNavigatorFeatureGuardProps,
} from './types.tsx';

const defaultFeatureContext: IssueNavigatorFeaturesContext = {
	isViewSwitcherEnabled: true,
	isLinkToOpenNewTab: true,
	isOnboardingEnabled: true,
	isExportMenuEnabled: true,
	isRowContextMenuEnabled: true,
	isSaveFilterButtonEnabled: true,
	isBulkChangeWorkItemsEnabled: true,
	isImportWorkItemsFromCSVEnabled: true,
};

const IssueNavigatorFeatureContext =
	createContext<IssueNavigatorFeaturesContext>(defaultFeatureContext);

const useIssueNavigatorFeatures = () => useContext(IssueNavigatorFeatureContext);

const IssueNavigatorFeatureProvider = ({
	children,
	...props
}: IssueNavigatorFeatureProviderProps) => {
	const value = useMemo(() => ({ ...defaultFeatureContext, ...props }), [props]);

	return (
		<IssueNavigatorFeatureContext.Provider value={value}>
			{children}
		</IssueNavigatorFeatureContext.Provider>
	);
};

const IssueNavigatorFeatureGuard = ({ featureKey, on, off }: IssueNavigatorFeatureGuardProps) => {
	const features = useIssueNavigatorFeatures();
	return features[featureKey] ? on : off;
};

export { IssueNavigatorFeatureProvider, useIssueNavigatorFeatures, IssueNavigatorFeatureGuard };
